<template>
  <div class="Search">
    <!-- s: header -->
    <header id="header-slidePanel">
      <h2>검색</h2>
      <div class="btn_back">
        <a @click="slidePanelClose"><img src="@/assets/images/btn_close.png" width="50" alt="이전"/></a>
      </div>
    </header>
    <!-- e: header -->
    <div class="contents-area-slidePanel" v-infinite-scroll="getBoardList" infinite-scroll-disabled="loading"
         infinite-scroll-distance="300">
      <div class="flex justify-between mrg-top-15">
        <select class="width-100 mrg-right-10" v-model="nMenuNum" @change="getCategoryList($event.target.value)">
          <option v-for="item in $store.state.boardList.community.child" :key="item.nMenuNum" :value="item.nMenuNum">
            {{ item.strMenuName }}
          </option>
          <option v-for="item in $store.state.boardList.serviceCenter.child" :key="item.nMenuNum"
                  :value="item.nMenuNum">{{ item.strMenuName }}
          </option>
        </select>
        <select class="width-100" v-model="strSearchMode">
          <option value="content">제목 + 내용</option>
          <option value="title">제목</option>
          <option valeu="user">작성자</option>
        </select>
      </div>
      <!-- 카테고리 -->
      <div class="mrg-top-15" v-if="boardCategory.length>0">
        <select class="width-100" v-model="nCategoryNum">
          <option value="">분류선택</option>
          <option v-for="item in boardCategory" :key="item.nCategoryNum" :value="item.nCategoryNum">
            {{ item.strCategoryName }}
          </option>
        </select>
      </div>
      <!-- 지역 -->
      <div class="mrg-top-15" v-if="boardRegion.length>0">
        <select class="width-100" v-model="nRegionNum">
          <option value="">지역선택</option>
          <option v-for="item in boardRegion" :key="item.nRegionNum" :value="item.nRegionNum">{{ item.strRegionName }}
          </option>
        </select>
      </div>
      <!-- 검색 -->
      <div class="search-area">
        <input type="text" placeholder="검색어를 입력하세요." v-model="strSearch"/>
        <button class="ir btn-input-del" @click="strSearch=''">초기화</button>
        <button class="ir btn-search" @click="searchBoard">검색</button>
      </div>
      <h3 class="searchTitle mrg-btm-10-10" v-if="boardList.length>0">검색결과 <strong>{{ searchTotalCnt }}건</strong> 이
        검색되었습니다.</h3>
      <div class="boardList boardFixd clearfix">
        <ul>
          <!-- 공지사항 -->
          <li v-for="data in boardNoticeList"
              :key="data.oBoard.nBoardIdx">
            <board-top-fix-style :data="data"/>
          </li>
          <!-- 상단고정 -->
          <li v-for="data in boardTopFixList"
              :key="data.oBoard.nBoardIdx">
            <board-top-fix-style :data="data"/>
          </li>
        </ul>
      </div>
      <!-- 일반게시글 -->
      <div class="boardList clearfix">
        <ul>
          <li v-for="data in boardList" :key="data.oBoard.nBoardIdx" :class="data.oBoard.strAtclType">
            <board-gallery-style v-if="strBoardStyle == 'GALLERY'" :data.sync="data"/>
            <board-event-style v-else-if="strBoardStyle == 'EVENT_BANNER'" :data.sync="data"/>
            <board-list-style v-else :data.sync="data"/>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import BoardTopFixStyle from "@/components/boardTopFixStyle";
import BoardListStyle from "@/components/boardListStyle";
import BoardGalleryStyle from "@/components/boardGalleryStyle";
import BoardEventStyle from "@/components/boardEventStyle";

export default {
  name: 'Search',
  components: {BoardTopFixStyle, BoardEventStyle, BoardGalleryStyle, BoardListStyle},
  data() {
    return {
      initLoading: false,          // 초기로딩 여부
      loading: false,              // 로딩여부
      listMore: true,              // 추가 페이지 여부
      page: 1,                     // 현재 페이지
      nMenuNum: this.storageGet('vuex', 'boardActiveCode') ? this.storageGet('vuex', 'boardActiveCode') : 1,
      nCategoryNum: 0,             // 각 게시판별 카테고리 번호 ( 전체 게시글을 확인할 땐.. 0 으로 전달 )
      strSearchMode: 'content',    // 검색모드 ( title :: 제목, content :: 제목+내용, user::사용자아이디)
      strSearch: '',               // 검색어
      boardCategory: {},           // 카테고리 관련 정보
      boardRegion: {},             // 지역 관련 정보
      strBoardStyle: 'LIST',       // 게시글 스타일
      boardList: [],               // 게시글 정보
      boardNoticeList: [],         // 공지사항 게시글
      boardTopFixList: [],         // 상단고정 게시글
      searchTotalCnt: 0,           // 검색결과
      isSending: false,            // 전송체크
    }
  },
  // 감시자
  watch: {},
  // $el 생성전
  created() {
  },
  // $el 생성후
  mounted() {
    window.callbackBackKey = this.callbackBackKey;
  },
  methods: {
    // APP 뒤로가기
    callbackBackKey() {
      this.slidePanelClose();
    },
    // 게시글 카테고리 리스트
    getCategoryList(code) {
      let param = {};
      this.ajaxGetAuth('/api/v1/category/list/' + code, param, this.getCategoryListResult);
    },
    // 게시글 카테고리 리스트 결과
    getCategoryListResult(response) {
      this.nCategoryNum = '';
      this.nRegionNum = '';
      if (response.result.code == 0) {
        this.boardCategory = response.oCategoryInfo.list;
        this.boardRegion = response.oRegionInfo.list;
      } else {
        this.boardCategory = {};
        this.boardRegion = {};
        this.toastMsg(response.result.resultNoti.message, 1500);
      }
    },
    // 게시글 검색
    searchBoard() {
      this.initLoading = true;
      this.listMore = true;
      this.boardList = [];
      this.boardNoticeList = [];
      this.boardTopFixList = [];
      this.page = 1;
      this.getBoardList();
    },
    // 게시글 검색
    getBoardList() {

      // 더블클릭 방지 체크
      if (this.isSending) {
        return false;
      }

      if (this.initLoading == false) {
        return false;
      }

      if (this.listMore == false) {
        return false;
      }

      this.loading = true;
      let param = {};
      param.nPage = this.page++;
      param.nCategoryNum = this.nCategoryNum;
      param.nRegionNum = this.nRegionNum;
      param.strSearchMode = this.strSearchMode;
      param.strSearch = this.strSearch;

      this.isSending = true;
      this.ajaxGetAuth('/api/v1/board/list/' + this.nMenuNum, param, this.getBoardListResult);
    },
    // 게시글 검색 결과
    getBoardListResult(response) {
      if (response.result.code == 0) {
        // 검색결과가 없을 경우
        if (response.oBoardInfo.setting.nBoardTotalCnt == 0) {
          this.boardList = [];
          this.page = 1;
          this.toastMsg(this.$store.state.messagesList.NO_POSTS_FOUND, 1500);
          return false;
        }

        let vm = this;
        // 게시글 리스트
        response.oBoardInfo.list.forEach(function (key) {

          if (response.oBoardInfo.setting.nNowPage == '1') {
            // 공지사항 게시글
            if (key.oBoard.strAtclType == 'NOTICE') {
              vm.boardNoticeList.push(key)
              // 상단고정 게시글
            } else if (key.oBoard.strAtclType == 'TOP_FIX') {
              vm.boardTopFixList.push(key)
            }
          }


          // 일반 게시글
          vm.boardList.push(key)

        })

        this.searchTotalCnt = response.oBoardInfo.setting.nBoardTotalCnt;
        this.strBoardStyle = response.oBoardInfo.setting.strBoardStyle

        // 현재 페이지와 마지막 페이지가 같은경우
        if (response.oBoardInfo.setting.nNowPage == response.oBoardInfo.setting.nMaxPage) {
          this.listMore = false;
        }
      } else {
        if (response.result.resultNoti.type == 'alert') {
          this.toastMsg(response.result.resultNoti.message, 1500)
        } else {
          this.errorMsg = response.result.resultNoti.message;
          this.errorField = response.result.resultNoti.validationFail.id;
        }
      }

      this.isSending = false;

      this.loading = false;
    },
  }
}
</script>

<style scoped>

</style>

